module.exports = __webpack_public_path__ + "img/Image4-two.0f5917ca.webp";